import { createReducer, on } from '@ngrx/store';
import { quizQuestionsActions } from '../actions/quiz-questions.actions';
import { QuizQuestion } from '../models';
import { PaginationParams } from '../types';

export interface QuizQuestionsState {
    loaded: boolean | null;
    loading: boolean | null;
    quizQuestions: QuizQuestion[];
    total: number;
    page: number;
    limit: number;
    lastParams: PaginationParams;
}

export const initialState: QuizQuestionsState = {
    loaded: null,
    loading: null,
    quizQuestions: [],
    total: 0,
    page: 1,
    limit: 20,
    lastParams: { page: 1, limit: 20 },
};

export const quizQuestionsReducer = createReducer(
    initialState,
    on(
        quizQuestionsActions.getQuizQuestions,
        (state, { value }): QuizQuestionsState => ({
            ...state,
            loading: true,
            page: value.page,
            limit: value.limit,
            lastParams: value,
        }),
    ),
    on(
        quizQuestionsActions.getQuizQuestionsSuccess,
        (state, { payload, total }): QuizQuestionsState => ({
            ...state,
            loaded: true,
            loading: false,
            quizQuestions: payload,
            total,
        }),
    ),
    on(
        quizQuestionsActions.getQuizQuestionsError,
        (state): QuizQuestionsState => ({
            ...state,
            loaded: false,
            loading: false,
        }),
    ),
    on(quizQuestionsActions.clear, (): QuizQuestionsState => ({ ...initialState })),
);
